import Vue from 'vue';
import './plugins/vuetify';
import { domain, clientId, audience } from './auth/auth0-variables.json';

// Import the plugin here
import { Auth0Plugin } from './auth/authWrapper';
import { VueLd } from 'vue-ld';

import App from './App.vue';

import store from './store';
import router from './router';
import StoreMixin from './mixins/store.mixin';
import LogRocket from 'logrocket';
import {
  ValidationObserver,
  ValidationProvider,
  extend,
  localize,
} from 'vee-validate';
import en from 'vee-validate/dist/locale/en.json';
const PhoneNumber = require('awesome-phonenumber');

import {
  numeric,
  required,
  max_value,
  min_value,
  email,
  double,
} from 'vee-validate/dist/rules';
localize({ en });
Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);
Vue.mixin(StoreMixin);
Vue.use(VueLd, {
  clientSideId: process.env.LAUNCHDARKLY,
  user: {
    anonymous: true,
  },
  readyBeforeIdentify: false,
});
extend('numeric', numeric);
extend('required', required);
extend('max_value', max_value);
extend('min_value', min_value);
extend('email', email);
extend('amount', {
  ...required,
  getMessage: field => `The ${field} is not a valid format.`,
});

extend('phonenumber', {
  // Custom validation message
  getMessage: field => `The ${field} is not a valid phone number.`,
  // Custom validation rule
  validate: value =>
    new Promise(resolve => {
      const pn = new PhoneNumber(value, 'AU');

      resolve({
        valid: pn.isValid() && !pn.isMobile(),
      });
    }),
});

extend('mobilenumber', {
  // Custom validation message
  getMessage: field => `The ${field} is not a valid mobile.`,
  // Custom validation rule
  validate: value =>
    new Promise(resolve => {
      var pn = new PhoneNumber(value, 'AU');
      resolve({
        valid: pn.isMobile(),
      });
    }),
});
extend('inbound', {
  // Custom validation message
  getMessage: field => `The ${field} is not a valid inbound.`,
  // Custom validation rule
  validate: value =>
    new Promise(resolve => {
      var pn = new PhoneNumber(value, 'AU');
      resolve({
        valid:
          pn.isValid() &&
          (pn.getType() == 'toll-free' || pn.getType() == 'shared-cost'),
      });
    }),
});

extend('dateofbirth', {
  // Custom validation message
  getMessage: field => `The ${field} is not a valid birthdate.`,
  // Custom validation rule
  validate: value =>
    new Promise(resolve => {
      // const [day, month, year] = value.substring(0, 10).split('/');
      var age = new Date(new Date() - new Date(value)).getFullYear() - 1970;
      resolve({
        valid: age > 17 && age < 100,
      });
    }),
});
extend('ampt', {
  // Custom validation message
  getMessage: field => `The ${field} is not a valid AMPT domain.`,
  // Custom validation rule
  validate: value =>
    new Promise(resolve => {
      resolve({
        valid: value.endsWith('vonex.biz') && value.length < 41,
      });
    }),
});

Vue.use(Auth0Plugin, {
  domain,
  clientId,
  audience,
  onRedirectCallback: appState => {
    router.push(
      appState && appState.targetUrl
        ? appState.targetUrl
        : window.location.pathname
    );
  },
});

import VueAnalytics from 'vue-analytics';
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
Sentry.init({
  environment: process.env.ENVIRONMENT,
  dsn: process.env.RAVEN,
  integrations: [
    new Integrations.Vue({ Vue, attachProps: true, logErrors: true }),
  ],
});
LogRocket.getSessionURL(sessionURL => {
  Sentry.configureScope(scope => {
    scope.setExtra('sessionURL', sessionURL);
  });
});

const isProd = process.env.NODE_ENV === 'production';
Vue.config.productionTip = !isProd;
const isDev = process.env.NODE_ENV !== 'production';
if (!isDev) LogRocket.init(process.env.LOGROCKET);

router.beforeEach((to, from, next) => {
  let dirty = JSON.parse(sessionStorage.getItem('dirty'));
  if (dirty)
    Vue.dialog
      .confirm({
        title: 'Unsaved Changes',
        body: 'Changes will be lost, Do you want to proceed?',
      })
      .then(function() {
        next();
      })
      .catch(function() {
        next(false);
      });
  else next();
});
Vue.use(VueAnalytics, {
  id: process.env.GOOGLE,
  router,
  autoTracking: {
    exception: true,
    //screenview: true
  },
  debug: {
    enabled: false,
    sendHitTask: isProd,
  },
});

const app = new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app');

if (window.Cypress) {
  // only available during E2E tests
  window.app = app;
}
